import { GetterNames } from './keys'
import { PatientWithDetailedReportState } from './types'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import { PatientWithDetailedReportsAttributes } from '@/jsonapi/PatientWithDetailedReports'

export type FlatPatientWithDetailedReports = FlatAPIData<PatientWithDetailedReportsAttributes>

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [GetterNames.patientWithDetailedReports]: (
    state: PatientWithDetailedReportState
  ): FlatPatientWithDetailedReports[] => {
    return state.patientWithDetailedReports.map(flattenJsonApiResponse)
  },
}
